import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderSlot as _renderSlot, toHandlerKey as _toHandlerKey, normalizeClass as _normalizeClass, renderList as _renderList, createSlots as _createSlots, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "common-rich-table-with-axios transition-opacity duration-100 relative" }
const _hoisted_2 = {
  key: 0,
  class: "z-30 px-3 pt-6 absolute top-0",
  style: {"left":"50%","transform":"translateX(-50%)","width":"128px"}
}
const _hoisted_3 = {
  class: "text-left",
  style: {"flex":"0 0 112px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-16" }, "ก่อนหน้า", -1)
const _hoisted_5 = { class: "flex-1 text-center items-center justify-center flex flex-col leading-snug" }
const _hoisted_6 = { class: "flex flex-row items-center mb-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 text-sm" }, "หน้าที่", -1)
const _hoisted_8 = { class: "text-gray-600 text-sm" }
const _hoisted_9 = { class: "text-gray-400 text-xs" }
const _hoisted_10 = {
  class: "text-right",
  style: {"flex":"0 0 112px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-16" }, "ถัดไป", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonLoadingBar = _resolveComponent("CommonLoadingBar")!
  const _component_CommonRichTable = _resolveComponent("CommonRichTable")!
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_CommonLoadingBar, { loading: true })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_CommonRichTable, {
      class: _normalizeClass({'opacity-25': _ctx.loading}),
      padding: _ctx.padding,
      option: _ctx.option,
      data: _ctx.data,
      orderBy: _ctx.orderBy,
      [_toHandlerKey(_ctx.clickRow)]: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickRow', $event))),
      onSort: _ctx.handleSortChange,
      onSearch: _ctx.handleSearchChange,
      startIncrement: (_ctx.pagination.perPage) ? ((_ctx.pagination.currentPage - 1) * _ctx.pagination.perPage) + 1 : 1,
      sortParameterName: _ctx.sortParameterName
    }, _createSlots({ _: 2 }, [
      _renderList(_ctx.$slots, (_, name) => {
        return {
          name: name,
          fn: _withCtx(({ item, index }) => [
            _renderSlot(_ctx.$slots, name, {
              item: item,
              index: index
            })
          ])
        }
      })
    ]), 1040, ["class", "padding", "option", "data", "orderBy", "onSort", "onSearch", "startIncrement", "sortParameterName"]),
    _createElementVNode("div", {
      class: _normalizeClass(["common-rich-table-with-graph-ql-pagionator flex bottom-0 left-0 right-0 filter-blur-saturate rounded-xl mt-3", {'p-3': _ctx.padding, 'sticky': !_ctx.isMobile, 'opacity-25': _ctx.loading}])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CommonButton, {
          small: "",
          level: "gray",
          disabled: _ctx.pagination.currentPage === 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.page = parseInt(_ctx.page, 10) - 1))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            class: "common-rich-table-page-input bg-transparent",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page) = $event))
          }, null, 512), [
            [_vModelText, _ctx.page]
          ]),
          _createElementVNode("div", _hoisted_8, "จาก " + _toDisplayString(_ctx.pagination.lastPage) + " หน้า", 1)
        ]),
        _createElementVNode("div", _hoisted_9, "รายการทั้งหมด " + _toDisplayString(_ctx.pagination.total) + " รายการ", 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_CommonButton, {
          small: "",
          level: "gray",
          disabled: !(_ctx.page < _ctx.pagination.lastPage),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.page = parseInt(_ctx.page, 10) + 1))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 2)
  ]))
}